import { Component, Input } from '@angular/core';

/**
 * Badge de sustentabilidad de un [[SlotsBatch|Lote]]: los esquemas (2BSvs,
 * EUDR, etc.) separados por " · ", o "Sustentable" si no se especificó ninguno.
 *
 * Usa un ícono de certificación y no la hoja, que ya identifica a la huella de
 * carbono ([[CarbonFootprintIconComponent]]).
 */
@Component({
  selector: 'ag-sustainable-badge',
  template: `<span *ngIf="quality?.sustainable" class="ag-label label-success"
    ><i class="material-symbols-rounded" aria-hidden="true">verified</i> <ng-container
    *ngIf="schemes; else sustainable">{{ schemes }}</ng-container><ng-template
    #sustainable>{{ 'ORDER_FORM.PRODUCT.SUSTAINABLE'|translate }}</ng-template></span>`,
  styles: [`
    .material-symbols-rounded { font-size: 1.2em; line-height: 0; vertical-align: -0.2em; }
  `]
})
export class SustainableBadgeComponent {

  @Input() public quality: { sustainable?: boolean, sustainable_schemes?: any[] };

  public get schemes(): string {
    return (this.quality?.sustainable_schemes || [])
      .map(scheme => scheme.abbrev || scheme.name)
      .join(' · ');
  }
}
